import Cookies from 'js-cookie'
import {
  ENCRYPTED_USER_ID_COOKIE_NAME,
  USER_LEVEL_TRACKING_ID_COOKIE_NAME,
} from './authentication/authentication-manager'
import { getLongTermCookieOptions } from './environments/config.js'

function extendCookieTime(cookieId) {
  const cookieVal = Cookies.get(cookieId)
  const localStorageVal = localStorage.getItem(cookieId)
  if (cookieVal) {
    Cookies.set(cookieId, cookieVal, {
      ...getLongTermCookieOptions(),
      secure: true,
    })
    localStorage.setItem(cookieId, cookieVal)
  } else if (localStorageVal) {
    Cookies.set(cookieId, localStorageVal, {
      ...getLongTermCookieOptions(),
      secure: true,
    })
  }
}

function initialize() {
  extendCookieTime(ENCRYPTED_USER_ID_COOKIE_NAME)
  extendCookieTime(USER_LEVEL_TRACKING_ID_COOKIE_NAME)
}

document.addEventListener('DOMContentLoaded', initialize, false)
